var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopyToWorkspaceTool = function SvgCopyToWorkspaceTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.095 12.5c1.052 0 1.904.852 1.904 1.904v12.692A1.904 1.904 0 0 1 29.095 29h-15.23a1.904 1.904 0 0 1-1.905-1.904v-3.053c.4.185.824.341 1.269.469v2.584c0 .35.286.635.635.635h15.231c.35 0 .635-.285.635-.635V15.673h-16.5l-.002 2.152c-.618-.504-1.03-1.285-1.269-2.387l.001-1.034c0-1.052.853-1.904 1.904-1.904h15.231zm-.635 4.442v9.52l-9.874-.001.635-.635h8.605v-8.25h-8.641l-.634-.634h9.91z",
    fill: "#0481A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14c.333 4.667 2.583 6.84 6.75 6.52v-2.8l4 4-4 4v-2.8c-5 .053-7.583-2.92-7.75-8.92h1zM23 4.5v6h-1.35V9.15l-3.301-3.301L6.35 5.85v10.8l.641.001c.078.469.173.919.287 1.35L5 18V4.5h18z",
    fill: "#707070"
  }))));
};

export default SvgCopyToWorkspaceTool;